import { FormatNumberWithCommas } from "../../../../shared/scripts/number-functions";
import { TableColumnGroup, TableColumnVisibilityController } from "../../../../shared/scripts/table-column-visibility";
import { RenderDateMDY, RenderNullableNumberWithSeparators, RenderProgressBar } from "../../../../shared/scripts/table-functions";
import { FinancialEntry } from "./financials.entities";
import { Unique } from "../../../../shared/scripts/array-functions";
import { IFilter } from "../../../../shared/scripts/filtering/filtering.entities";
import { GetSelectedDate, GetSelectedDropdownValues, InitializeDateSelector, InitializeFilterDropdown } from "../../../../shared/scripts/filtering/filtering.utilities";

export class InvoicesTable implements IFilter {

    tableId: string = "invoices-table";
    tableWrapperId: string = this.tableId + "_wrapper";
    modalTableId: string = "invoice-modal-table";
    modalTableWrapperId: string = this.modalTableId + "_wrapper";
    dataTable: any;
    modalDataTable: any;
    tableColumnController: TableColumnVisibilityController;
    modalTableColumnController: TableColumnVisibilityController;
    allInvoices: FinancialEntry[];
    currentInvoices: FinancialEntry[];

    constructor(financials: FinancialEntry[]) {

        financials.forEach(financial => financial.initialize());
        this.allInvoices = financials;
        this.currentInvoices = this.allInvoices;
        this.initializeDataTable();

        $('a[data-toggle="tab"]').on('shown.bs.tab', (e) => {
            //to setup dropdowns to go downwards

            if (e.currentTarget.id == "invoices-tab") {
                ['#study-dropdown', '#vendor-dropdown', '#invoice-status-dropdown'].forEach((id: string) => $(id).selectpicker("refresh"));
            }
        });

        return this;
    }

    initializeDataTable() {
        let columns: any[] = [
            { data: { _: "StudyName", display: "StudyNameDisplay" }, title: "Category", className: "study text-left font-size12 nowrap" },
            { data: { _: "VendorName", display: "VendorNameDisplay" }, title: "Vendor", className: "vendor-name text-left font-size12 nowrap" },
            { data: { _: "Subcontract", display: "SubcontractDisplay" }, title: "Subcontract #", className: "subcontract text-left font-size12 nowrap" },
            { data: { _: "POID", display: "POIDDisplay" }, title: "PO/Vendor<br/>ID", className: "poid text-center font-size12 nowrap" },
            { data: { _: "ProjectLevel", display: "ProjectLevelDisplay" }, title: "Project<br/>Code", className: "project-level text-center font-size12 nowrap" },
            //{ data: { _: "SubcontractStartDateCompare", display: "SubcontractStartDateDisplay" }, title: "Subcontract Start Date", className: "subcontract-start-date text-left font-size12 nowrap" },
            //{ data: { _: "SubcontractEndDateParsed", display: "SubcontractEndDateDisplay" }, title: "Subcontract End Date", className: "subcontract-end-date text-left font-size12 nowrap" },
            //{ data: "SubcontractType", title: "Subcontract Type", className: "subcontract-type text-left font-size12 nowrap" },
            //{ data: { _: "FundedCommitmentAmount", display: "FundedCommitmentAmountDisplay" }, title: "Total Unrestricted Funds", className: "funded-commitment-amount text-left font-size12 nowrap" },
            //{ data: { _: "RestrictedFunds", display: "RestrictedFundsDisplay" }, title: "Total Restricted Funds", className: "restricted-funds text-left font-size12 nowrap" },
            //{ data: { _: "SubcontractSubcontractAmount", display: "SubcontractSubcontractAmountDisplay" }, title: "Total Subcontract Amount", className: "subcontract-funded-amount text-left font-size12 nowrap" },
            { data: { _: "RemainingCommitmentAmount", display: "RemainingCommitmentAmountDisplay" }, title: "Remaining<br/>Unrestricted<br/>At-Date", className: "remaining-commitment-amount text-center font-size12 nowrap" },
            { data: { _: "InvoicedToDate", display: "InvoicedToDateDisplay" }, title: "Invoiced<br/>To-Date", className: "invoiced-to-date text-center font-size12 nowrap"},
            { data: "InvoiceNumber", title: "Invoice #", className: "invoice-number text-left font-size12 nowrap" },
            { data: { _: "InvoiceDateCompare", display: "InvoiceDateDisplay" }, title: "Invoice<br/>Date", className: "invoice-date text-center font-size12 nowrap" },
            { data: { _: "InvoicedAmount", display: "InvoicedAmountDisplay" }, title: "Invoiced<br/>Amount", className: "invoiced-amount text-center font-size12 nowrap" },
            { data: "InvoiceStatus", title: "Invoice<br/>Status", className: "invoice-status text-center font-size12 nowrap" },
            //{ data: "EntryType", title: "Record<br/>Type", className: "entry-type text-center font-size12 nowrap" },
        ];

        let tableColumnGroups: TableColumnGroup[] = [
            //new TableColumnGroup("Project", true, [], "project"),

            //new TableColumnGroup("Category", true, [], "study"),
            new TableColumnGroup("Vendor", true, [], "vendor-name"),
            new TableColumnGroup("Subcontract #", false, [], "subcontract"),
            new TableColumnGroup("PO/Vendor ID", false, [], "poid"),
            new TableColumnGroup("Project Code", false, [], "project-level"),
            //new TableColumnGroup("Subcontract Start Date", false, [], "subcontract-start-date"),
            //new TableColumnGroup("Subcontract End Date", true, [], "subcontract-end-date"),
            //new TableColumnGroup("Subcontract Type", false, [], "subcontract-type"),
            //new TableColumnGroup("Total Unrestricted Funds", false, [], "funded-commitment-amount"),
            //new TableColumnGroup("Total Restricted Funds", false, [], "restricted-funds"),
            //new TableColumnGroup("Total Subcontract Amount", false, [], "subcontract-funded-amount"),
            new TableColumnGroup("Remaining Unrestricted At-Date", false, [], "remaining-commitment-amount"),
            new TableColumnGroup("Invoiced To-Date", false, [], "invoiced-to-date"),
            new TableColumnGroup("Invoice #", true, [], "invoice-number"),
            new TableColumnGroup("Invoice Date", true, [], "invoice-date"),
            new TableColumnGroup("Invoiced Amount", true, [], "invoiced-amount"),
            new TableColumnGroup("Invoice Status", true, [], "invoice-status"),
            //new TableColumnGroup("Record Type", false, [], "entry-type"),
        ];

        this.dataTable = $('#' + this.tableId).DataTable({
            "dom": '<"top-controls"<"column-select"><"added-since"><"search-bar"f><"spacer"><"count-found"B>>rtip',
            autoWidth: true,
            info: false,
            paging: true,
            pagingType: 'simple',
            pageLength: 50,
            search: true,
            scrollX: true,
            scrollY: '70vh',
            scrollCollapse: true,
            orderCellsTop: true,
            fixedColumns: {
                leftColumns: 1
            },
            columns: columns,
            buttons: [
                {
                    extend: 'csv',
                    text: '<i class="fas fa-file-download"></i>',
                    titleAttr: 'CSV',
                    charset: 'utf-8',
                    title: "RECOVER-CT Invoices Export"
                    //exportOptions: {
                    //    columns: [1, 2, 3, 4]
                    //}
                }
            ],
            order: [
                [0, 'asc'],
                [1, 'asc'],
                [8, 'desc']
            ],
            data: this.allInvoices
        });

        $("#" + this.tableWrapperId + " .top-controls").addClass('row mx-0');

        $("#" + this.tableWrapperId + " .column-select").addClass('col-12 col-md-3 px-0');
        $("#" + this.tableWrapperId + " .column-select").empty().html('<div id="' + this.tableId + '-column-select"></div>');

        $("#" + this.tableWrapperId + " .search-bar").addClass('col-12 col-md-3');

        $("#" + this.tableWrapperId + " .spacer").addClass('col-12 col-md-3');
        $("#" + this.tableWrapperId + " .count-found").addClass('col-12 col-md-3 d-flex justify-content-end vertical-align-middle align-self-end mt-2 pr-0');
        //<span id="people-found-count" class="font-italic font-size12" > </span>
        $("#" + this.tableWrapperId + " .count-found").prepend('<div class=\"table-message d-inline-block align-self-center mr-2\"><span id=\"' + this.tableId + '-found-count\"></span></div>');
        $("#" + this.tableWrapperId + " .count-found").prepend('<div class=\"table-message d-inline-block align-self-center mr-2\"></div>');

        this.tableColumnController = new TableColumnVisibilityController(this.tableId, (this.tableId + '-column-select'), tableColumnGroups);

        $('#' + this.tableId).on('search.dt', (e, settings) => {
            this.setCountFoundLabel(this.dataTable.rows({ search: 'applied' }).count());
        });
        this.setCountFoundLabel(this.allInvoices.length);

        this.initializeDatePickers();
        this.initializeFilters(this.allInvoices);

        /*this.initializeModalLinks('#' + this.tableId);
        this.dataTable.on('draw', (e, settings) => {
            this.initializeModalLinks('#' + this.tableId);
        });*/

        $("#invoices-tab").on('click', () => {
            setTimeout(() => {
                this.dataTable.columns.adjust().draw();
            }, 500)
        });
        
    }

    setCountFoundLabel(count: number): void {

        switch (count) {
            case 0: $('#' + this.tableId + '-found-count').text("No Entries Found"); break;
            case 1: $('#' + this.tableId + '-found-count').text("1 Entry Found"); break;
            default: $('#' + this.tableId + '-found-count').text(FormatNumberWithCommas(count + "") + " Entries Found");
        }
    }

    setModalCountFoundLabel(count: number): void {

        switch (count) {
            case 0: $('#' + this.modalTableId + '-found-count').text("No Entries Found"); break;
            case 1: $('#' + this.modalTableId + '-found-count').text("1 Entry Found"); break;
            default: $('#' + this.modalTableId + '-found-count').text(FormatNumberWithCommas(count + "") + " Entries Found");
        }
    }

    refresh(): void {
        this.dataTable.columns.adjust();
        this.tableColumnController.refresh();
    }

    updateContent(financials: FinancialEntry[]): void {
        this.dataTable.clear();
        this.dataTable.rows.add(financials).draw();

        this.setCountFoundLabel(financials.length);

        // reinitialize the links in table (old ones have been removed)
        //this.initializeModalLinks('#' + this.tableId);
    }

    clearSearchBar(): void {
        this.dataTable.search('').draw();
    }

    initializeDatePickers() {
        InitializeDateSelector("added-since-date", this);
        InitializeDateSelector("added-before-date", this);
    }

    initializeFilters(financials: FinancialEntry[]) {
        let studiesLists: string[] = [];
        this.allInvoices.map(invoice => {
            if (!studiesLists.includes(invoice.StudyName) && invoice.StudyName != null && invoice.StudyName != "") {
                studiesLists.push(invoice.StudyName);
            }
        })
        studiesLists.sort();
        let studiesAtEnd: string[] = ["Infrastructure", "Other CT ACC Subcontracts", "Committee Members"]
        studiesAtEnd.forEach(studyName => {
            let foundIndex = studiesLists.findIndex(study => study == studyName);
            if (foundIndex != -1) {
                studiesLists.splice(foundIndex, 1);
                studiesLists.push(studyName);
            }
        })

        InitializeFilterDropdown('#study-dropdown', studiesLists, this);
        InitializeFilterDropdown('#invoice-status-dropdown', Unique(this.allInvoices.map((invoice: FinancialEntry) => invoice.InvoiceStatus), true), this);
        InitializeFilterDropdown('#vendor-dropdown', Unique(this.allInvoices.map((invoice: FinancialEntry) => invoice.VendorName), true), this);
        //InitializeFilterDropdown('#entry-type-dropdown', Unique(this.allInvoices.map(invoice => invoice.EntryType), true), this);
    }

    triggerFilter(): void {
        //console.log("filter triggered");
        let invoices = this.allInvoices;

        // Study
        invoices = invoices.filter(invoice => GetSelectedDropdownValues("#study-dropdown").includes(invoice.StudyName)); 
        // Project
        invoices = invoices.filter(invoice => GetSelectedDropdownValues("#invoice-status-dropdown").includes(invoice.InvoiceStatus));
        // Status
        invoices = invoices.filter(invoice => GetSelectedDropdownValues("#vendor-dropdown").includes(invoice.VendorName));
        // Entry Type
        //invoices = invoices.filter(invoice => GetSelectedDropdownValues("#entry-type-dropdown").includes(invoice.EntryType));
        // Date
        if (GetSelectedDate("#added-since-date") != null) {
            let addedSinceDateString: string = GetSelectedDate("#added-since-date");
            let addedSinceDate: Date = new Date(addedSinceDateString);

            invoices = invoices.filter(invoice => {
                if (invoice.InvoiceDateCompare == null) {
                    return false;
                }
                if (invoice.InvoiceDateCompare >= addedSinceDate) {
                    return true;
                }
                else {
                    return false;
                }
            });
        }
        if (GetSelectedDate("#added-before-date") != null) {
            let addedSinceDateString: string = GetSelectedDate("#added-before-date");
            let addedSinceDate: Date = new Date(addedSinceDateString);

            invoices = invoices.filter(invoice => {
                if (invoice.InvoiceDateCompare == null) {
                    return false;
                }
                if (invoice.InvoiceDateCompare <= addedSinceDate) {
                    return true;
                }
                else {
                    return false;
                }
            });
        }
        this.currentInvoices = invoices;
        this.updateContent(invoices)
    }

    initializeModalLinks(tableId: string): void {
        let invoicesTable = this;
        // remove any existing click events (don't want to have multiple attached)
        $(tableId + " .modal-link").off('click');

        // add click event
        $(tableId + " .modal-link").on('click', function () {
            //console.log("Loading Content...");
            // Show loading for modal
            $("#invoice-table-modal .loading").removeClass("d-none");
            $("#invoice-table-modal .loaded-content").addClass("d-none");
          
            let filterField = "";
            let filterText = $(this).text();
            let displayName = "";

            if ($(this).hasClass("study-modal")) {
                filterField = "StudyName";
                displayName = "Category Name";
            }
            if ($(this).hasClass("project-name-modal")) {
                filterField = "ProjectName";
                displayName = "Project Name";
            }
            if ($(this).hasClass("poid-modal")) {
                filterField = "POID";
                displayName = "PO/Vendor ID"
            }
            if ($(this).hasClass("project-level-modal")) {
                filterField = "ProjectLevel";
                displayName = "Project Code / Charge Category";
            }
            if ($(this).hasClass("project-number-modal")) {
                filterField = "ProjectNumber";
                displayName = "Project Number";
            }
            if ($(this).hasClass("vendor-name-modal")) {
                filterField = "VendorName";
                displayName = "Vendor Name"
            }
            if ($(this).hasClass("subcontract-modal")) {
                filterField = "Subcontract";
                displayName = "Subcontract";
            }
            if ($(this).hasClass("subcontract-company-name-modal")) {
                filterField = "SubcontractCompanyName";
                displayName = "Subcontract Company Name";
            }

            // Set Title
            $("#invoice-table-name").text(`${displayName}: ${filterText}`);

            invoicesTable.loadModal(filterField, filterText);

            // Show Content
            setTimeout(() => {
                //console.log("Loaded!");
                $("#invoice-table-modal .loading").addClass("d-none");
                $("#invoice-table-modal .loaded-content").removeClass("d-none");
                invoicesTable.modalDataTable.columns.adjust().draw();
            }, 1000)
            
        });
    }

    loadModal(fieldName: string, fieldText: string): void {
        // Filter Invoices based on selected field
        //let filteredInvoices = this.allInvoices.filter(invoice => invoice[fieldName] == fieldText);      
        let filteredInvoices = this.currentInvoices.filter(invoice => invoice[fieldName] == fieldText);      

        // Create Table
        this.loadModalTable(filteredInvoices);

        // Show Modal
        if (!$("#invoice-table-modal").hasClass("show")) {
            $("#invoice-table-modal").modal("show");
        }

    }

    loadModalTable(filteredInvoices: FinancialEntry[]): void {
        if (this.modalDataTable) {
            this.modalDataTable.destroy();
            $('#' + this.modalTableId).empty();
        }  

        let modalColumns: any[] = [
            { data: { _: "StudyName", display: "StudyNameDisplay" }, title: "Category", className: "modal-study text-left font-size12 nowrap" },
            { data: { _: "VendorName", display: "VendorNameDisplay" }, title: "Vendor", className: "modal-vendor-name text-left font-size12 nowrap" },
            { data: { _: "Subcontract", display: "SubcontractDisplay" }, title: "Subcontract #", className: "modal-subcontract text-left font-size12 nowrap" },
            { data: { _: "POID", display: "POIDDisplay" }, title: "PO/Vendor ID", className: "modal-poid text-left font-size12 nowrap" },
            { data: { _: "ProjectLevel", display: "ProjectLevelDisplay" }, title: "Project Code", className: "modal-project-level text-left font-size12 nowrap" },
            { data: { _: "SubcontractStartDateCompare", display: "SubcontractStartDateDisplay" }, title: "Subcontract Start Date", className: "modal-subcontract-start-date text-left font-size12 nowrap" },
            { data: { _: "SubcontractEndDateCompare", display: "SubcontractEndDateDisplay" }, title: "Subcontract End Date", className: "modal-subcontract-end-date text-left font-size12 nowrap" },
            { data: "SubcontractType", title: "Subcontract Type", className: "modal-subcontract-type text-left font-size12 nowrap" },
            { data: { _: "FundedCommitmentAmount", display: "FundedCommitmentAmountDisplay" }, title: "Total Unrestricted Funds", className: "modal-funded-commitment-amount text-left font-size12 nowrap" },

            { data: { _: "SubcontractSubcontractAmount", display: "SubcontractSubcontractAmountDisplay" }, title: "Total Subcontract Amount", className: "modal-subcontract-funded-amount text-left font-size12 nowrap" },

            { data: { _: "RestrictedFunds", display: "RestrictedFundsDisplay" }, title: "Total Restricted Funds", className: "modal-restricted-funds text-left font-size12 nowrap" },
            { data: { _: "RemainingCommitmentAmount", display: "RemainingCommitmentAmountDisplay" }, title: "Remaining Unrestricted Funds", className: "modal-remaining-commitment-amount text-left font-size12 nowrap" },
            { data: "InvoiceNumber", title: "Invoice #", className: "modal-invoice-number text-left font-size12 nowrap" },
            { data: { _: "InvoiceDateCompare", display: "InvoiceDateDisplay" }, title: "Invoice Date", className: "modal-invoice-date text-left font-size12 nowrap" },
            { data: { _: "InvoicedAmount", display: "InvoicedAmountDisplay" }, title: "Invoiced Amount", className: "modal-invoiced-amount text-left font-size12 nowrap" },
            { data: "InvoiceStatus", title: "Invoice Status", className: "modal-invoice-status text-left font-size12 nowrap" },
            { data: "EntryType", title: "Record Type", className: "modal-entry-type text-left font-size12 nowrap" },
            //{ data: "VendorNumber", title: "Vendor Number", className: "modal-vendor-info modal-vendor-number text-left font-size12 nowrap" },
            //{ data: { _: "ProjectName", display: "ProjectNameDisplay" }, title: "Project", className: "modal-project text-left font-size12 nowrap" },
            //{ data: { _: "ProjectNumber", display: "ProjectNumberDisplay" }, title: "Project Number", className: "modal-project-info modal-project-number text-left font-size12 nowrap" },
            //{ data: { _: "POEndDateCompare", display: "POEndDateDisplay" }, title: "PO End Date", className: "modal-po-end-date text-left font-size12 nowrap" },
            //{ data: "POReleaseNumber", title: "PO Release Number", className: "modal-project-info modal-po-release-number text-left font-size12 nowrap" },
            //{ data: { _: "SubcontractCompanyName", display: "SubcontractCompanyNameDisplay" }, title: "Subcontract Company Name", className: "modal-subcontract-info modal-subcontract-company-name text-left font-size12 nowrap" },
        ];           

        this.modalDataTable = $('#' + this.modalTableId).DataTable({
            "dom": '<"top-controls"<"column-select"><"search-bar"f><"spacer"><"count-found"B>>rtip',
            autoWidth: true,
            info: false,
            paging: true,
            pagingType: 'simple',
            pageLength: 25,
            search: true,
            scrollX: true,
            scrollY: '50vh',
            scrollCollapse: true,
            orderCellsTop: true,
            fixedColumns: {
                leftColumns: 1
            },
            columns: modalColumns,
            buttons: [
                {
                    extend: 'csv',
                    text: '<i class="fas fa-file-download"></i>',
                    titleAttr: 'CSV',
                    charset: 'utf-8',
                    //exportOptions: {
                    //    columns: [1, 2, 3, 4]
                    //}
                }
            ],
            order: [
                [0, 'asc'],
                [1, 'asc'],
                [13, 'desc']
            ],
            data: filteredInvoices,
            /*"initComplete": function (settings, json) {
                
            }*/
        });

        let selectedColumns: string[] = GetSelectedDropdownValues("#invoices-table-column-filter-dropdown");

        let modalTableColumnGroups: TableColumnGroup[] = [
            new TableColumnGroup("Category", selectedColumns.includes("Category"), [], "modal-study"),
            new TableColumnGroup("Vendor", selectedColumns.includes("Vendor"), [], "modal-vendor-name"),
            new TableColumnGroup("Subcontract #", selectedColumns.includes("Subcontract #"), [], "modal-subcontract"),
            new TableColumnGroup("PO/Vendor ID", selectedColumns.includes("ID"), [], "modal-poid"),
            new TableColumnGroup("Project Code", selectedColumns.includes("Project Code / Charge Category"), [], "modal-project-level"),
            new TableColumnGroup("Subcontract Start Date", selectedColumns.includes("Subcontract Start Date"), [], "modal-subcontract-start-date"),
            new TableColumnGroup("Subcontract End Date", selectedColumns.includes("Subcontract End Date"), [], "modal-subcontract-end-date"),
            new TableColumnGroup("Subcontract Type", selectedColumns.includes("Subcontract Type"), [], "modal-subcontract-type"),
            new TableColumnGroup("Total Unrestricted Funds", selectedColumns.includes("Total Unrestricted Funds"), [], "modal-funded-commitment-amount"),
            new TableColumnGroup("Total Restricted Funds", selectedColumns.includes("Total Restricted Funds"), [], "modal-restricted-funds"),
            new TableColumnGroup("Total Subcontract Amount", selectedColumns.includes("Total Subcontract Amount"), [], "modal-subcontract-funded-amount"),
            new TableColumnGroup("Remaining Unrestricted Funds", selectedColumns.includes("Remaining Unrestricted Funds"), [], "modal-remaining-commitment-amount"),
            new TableColumnGroup("Invoice #", selectedColumns.includes("Invoice #"), [], "modal-invoice-number"),
            new TableColumnGroup("Invoice Date", selectedColumns.includes("Invoice Date"), [], "modal-invoice-date"),
            new TableColumnGroup("Invoiced Amount", selectedColumns.includes("Invoiced Amount"), [], "modal-invoiced-amount"),
            new TableColumnGroup("Invoice Status", selectedColumns.includes("Invoice Status"), [], "modal-invoice-status"),
            new TableColumnGroup("Record Type", selectedColumns.includes("Record Type"), [], "modal-entry-type"),
        ];

        $("#" + this.modalTableWrapperId + " .top-controls").addClass('row mx-0');

        $("#" + this.modalTableWrapperId + " .column-select").addClass('col-12 col-md-3 px-0');
        $("#" + this.modalTableWrapperId + " .column-select").empty().html('<div id="' + this.modalTableId + '-column-select"></div>');

        $("#" + this.modalTableWrapperId + " .search-bar").addClass('col-12 col-md-3');

        $("#" + this.modalTableWrapperId + " .spacer").addClass('col-12 col-md-3');
        $("#" + this.modalTableWrapperId + " .count-found").addClass('col-12 col-md-3 d-flex justify-content-end vertical-align-middle align-self-end mt-2 pr-0');
        //<span id="people-found-count" class="font-italic font-size12" > </span>
        $("#" + this.modalTableWrapperId + " .count-found").prepend('<div class=\"table-message d-inline-block align-self-center mr-2\"><span id=\"' + this.modalTableId + '-found-count\"></span></div>');
        $("#" + this.modalTableWrapperId + " .count-found").prepend('<div class=\"table-message d-inline-block align-self-center mr-2\"></div>');

        this.modalTableColumnController = new TableColumnVisibilityController(this.modalTableId, (this.modalTableId + '-column-select'), modalTableColumnGroups);

        $('#' + this.modalTableId).on('search.dt', (e, settings) => {
            this.setModalCountFoundLabel(this.modalDataTable.rows({ search: 'applied' }).count());
        });

        this.setModalCountFoundLabel(filteredInvoices.length);

        this.initializeModalLinks("#" + this.modalTableId);
        this.modalDataTable.on('draw', () => {
            this.initializeModalLinks("#" + this.modalTableId);
        })      
        
    }

    /*initializeModal(): void {
        // Runs after modal has finished opening
        $('#invoice-table-modal').on('shown.bs.modal', (e) => {
            // Readjust columns
            //this.modalDataTable.columns.adjust().draw();
        })
    }*/
}